<template>
  <section class="ctn">
    <section class="table">
      <heim-table :data="filteredTypes" :columns="['id', 'type']" cols="7">
        <template slot="thead" slot-scope="props">
          <th class="collapse only-mobile"></th>
          <th class="id sortable" @click="props.sortBy('id')">#<heim-icon :icon="props.sortOrders['id'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="sortable main" @click="props.sortBy('type')">{{ $t('siteType') }}<heim-icon :icon="props.sortOrders['type'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="nb">{{ $t('nbSite') }}</th>
          <th class="nb">{{ $t('nbProject') }}</th>
          <th class="action activity"></th>
          <th class="action details"></th>
        </template>
        <template slot="tbody" slot-scope="{ item, index, show, openDetail, cols }">
          <tr :key="'siteType-'+index">
            <td class="only-mobile">
							<heim-icon-button
								:class="show(item)?'opened':''"
								class="icon-button"
								@click.native="openDetail(item)">
								<heim-icon icon="chevron-right"></heim-icon>
							</heim-icon-button>
						</td>
            <td class="id" data-title="#">{{item.id}}</td>
            <td data-title="Servers">
                <span class="label">{{item.type}}</span>
            </td>
            <td class="nb">
              <span>{{ /* item.Type.length */}}</span>
            </td>
            <td class="nb">
              <span>{{ /* item.Project.length */}}</span>
            </td>
            <td class="activity" data-title="Activity">
              <router-link class="paper-action" :to="{ path: `/types/${item.id}/details` }">
                <heim-icon icon="timeline"></heim-icon><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
            </td>
            <td class="details mobile-link"><router-link class="link"  :to="{ path: `/types/${item.id}/details`}"><heim-icon icon="chevron-right"></heim-icon></router-link></td>
          </tr>
          <transition name="slide-fade" :key="'detail-'+index">
						<tr v-if="show(item)" class="detail only-mobile" :data-detail="item.id">
							<td class="detail-row" :colspan="cols">
								<div class="detail-container">
									<div class="row">
										<div class="item">
											<span class="label">{{ $t('nbSite') }}</span>
											<div>{{ /* item.Sites.length */ }}</div>
										</div>
										<div class="item">
											<span class="label">{{ $t('nbProject') }}</span>
											<div>{{ /* item.Projects.length */ }}</div>
										</div>
									</div>
								</div>
							</td>
						</tr>
					</transition>
        </template>
      </heim-table>
    </section>
  </section>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon.vue";
import HeimIconButton from "@/components/form/button/heim-icon-button.vue";
import HeimTable from "@/components/layout/list/heim-table.vue";
import { mapState } from "vuex";
import fuseMixin from "@/mixins/fuse";

export default {
  name: "SiteTypesList",
  components: {
    HeimIcon,
    HeimIconButton,
    HeimTable
  },
  mixins: [fuseMixin],
  mounted() {
    this.$store.dispatch("getSiteTypes");
    // we need to setup fuse inside a watcher
    // because otherwise fuse setups itselfs
    // with an empty array (no data has arrived yet)
    this.$watch(
      vm => vm.siteTypes,
      val => {
        this.setupTypes();
      }
    );
    this.setupTypes();

    this.$store.dispatch("setTitle", "Techno");
  },
  computed: {
    ...mapState(["search"]),
    ...mapState({ siteTypes: state => state.typesState.siteTypes })
  }
};
</script>

<style scoped>
.disabled {
  color: #8b969c;
}
</style>
